import script from "./StatisticCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticCard.vue?vue&type=script&setup=true&lang=js"

import "./StatisticCard.vue?vue&type=style&index=0&id=78a3abea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a3abea"]])

export default __exports__